/*
 * The supporters component holds logic to display supporter companies.
 */

import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@components/base/base.component';
import { BaseService } from '@services/base/base.service';
import { SupportersService } from '@services/supporters/supporters.service';

@Component({
    selector: 'app-component-supporters',
    templateUrl: 'supporters.component.html',
    styleUrls: ['supporters.component.less']
})
export class SupportersComponent extends BaseComponent implements OnInit {

    constructor(
        public baseService: BaseService,
        private supportersService: SupportersService
    ) {
        super(baseService);
    }

    ngOnInit() {
        this.item = this.supportersService.get('name,url,image');
    }
}